import { render, staticRenderFns } from "./AuthorGalleryItem.vue?vue&type=template&id=3b1baf54&"
import script from "./AuthorGalleryItem.vue?vue&type=script&lang=js&"
export * from "./AuthorGalleryItem.vue?vue&type=script&lang=js&"
import style0 from "./AuthorGalleryItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports